import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './DashboardPages.css';

const Profile = () => {
  const { user } = useAuth();

  return (
    <div className="page-container">
      <h2 className="page-title">Profile</h2>

      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-avatar">
            {user?.name?.charAt(0).toUpperCase()}
          </div>
          <div className="profile-info">
            <h3>{user?.name}</h3>
            <p>@{user?.username}</p>
          </div>
        </div>

        <div className="profile-details">
          <div className="detail-item">
            <label>Full Name</label>
            <p>{user?.name}</p>
          </div>
          <div className="detail-item">
            <label>Username</label>
            <p>{user?.username}</p>
          </div>
          <div className="detail-item">
            <label>Email</label>
            <p>{user?.email}</p>
          </div>
          <div className="detail-item">
            <label>Member Since</label>
            <p>{new Date(user?.created_at).toLocaleDateString()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
